import useRoleContext from './context';
import RoleProvider from './provider';

export { RoleProvider };
export default useRoleContext;
